/**
 * Get value of parameter in url
 * @param {string} name 
 * @returns value of parameter in url
 */
export const getUrlParameter = (name) => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get(name);
    return myParam
  }
  else {
    return null;
  }
};

/**
 * Check if url has a particular parameter
 * @param {string} name 
 * @returns boolean
 */
export const hasUrlParameter = (name) => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(name);
  }
};